<template>
    <div>
      <!-- Fondo oscuro -->
      <div
        v-if="open"
        class="fixed inset-0 bg-black/40 z-40"
        @click="closeSidebar"
      ></div>
  
      <!-- Sidebar -->
      <div
        class="fixed top-0 right-0 w-[380px] h-full bg-white shadow-2xl z-[1000] flex flex-col transition-transform duration-300"
        :class="open ? 'translate-x-0' : 'translate-x-full'"
      >
        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b">
          <h2 class="text-md font-medium font-opensans">Tu carrito • {{ cartCount }}</h2>
          <button @click="closeSidebar" class="text-gray-500 text-xl hover:bg-gray-300 hover:text-black w-8 h-8 rounded-md">&times;</button>
        </div>
  
        <!-- Contenido -->
        <div class="flex-1 overflow-y-auto p-4">
          <div v-if="items.length === 0" class="text-center text-gray-500">
            Tu carrito está vacío.
          </div>
  
          <div
            v-for="item in items"
            :key="item.id"
            class="flex gap-3 mb-6 pb-4 border-b"
          >
            <img :src="item.image" class="w-20 h-20 object-cover rounded" />
  
            <div class="flex-1">
              <div class="font-semibold text-sm leading-tight">
                {{ item.name }}
              </div>
  
              <div class="text-xs text-gray-500" v-if="item.optionName">
                {{ item.optionName }}
              </div>
  
              <button
                @click="removeItem(item.id)"
                class="text-xs text-red-600 underline mt-1"
              >
                Eliminar
              </button>
  
              <div class="flex items-center gap-2 mt-2">
                <button @click="decrease(item)" class="w-6 h-6 border rounded text-sm">-</button>
                <span class="text-sm">{{ item.quantity }}</span>
                <button @click="increase(item)" class="w-6 h-6 border rounded text-sm">+</button>
              </div>
  
              <div class="text-sm mt-1 font-semibold">
                {{ formatNumber(item.total) }} €
              </div>
            </div>
          </div>
        </div>
  
        <!-- Footer -->
        <div class="border-t p-4">
          <div class="flex justify-between mb-4 font-semibold">
            <span>Total</span>
            <span>{{ formatNumber(cartTotal) }} €</span>
          </div>
  
          <button 
            class="w-full bg-sky-900 text-white py-3 rounded-lg text-sm font-semibold"
            @click="checkout()">
            Finalizar compra • {{ formatNumber(cartTotal) }} €
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  export default {
    name: "CartSidebar",
  
    props: {
      open: {
        type: Boolean,
        default: false
      }
    },
  
    data() {
      return {
        items: [],
        storageKey: "cart_items"
      }
    },
  
    watch: {
      open(newVal) {
        if (newVal) this.loadCart()
      }
    },
  
    computed: {
      cartCount() {
        return this.items.reduce((sum, i) => sum + (i.quantity || 0), 0)
      },
      cartTotal() {
        return this.items.reduce((sum, i) => sum + (i.total || 0), 0)
      }
    },
  
    methods: {
      loadCart() {
        try {
          const raw = localStorage.getItem(this.storageKey)
          this.items = raw ? JSON.parse(raw) : []
        } catch {
          this.items = []
        }
      },
  
      saveCart() {
        localStorage.setItem(this.storageKey, JSON.stringify(this.items))
      },
  
      closeSidebar() {
        this.$emit("close")
      },
  
      formatNumber(num) {
        return new Intl.NumberFormat("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(num || 0)
      },
  
      removeItem(id) {
        this.items = this.items.filter(item => item.id !== id)
        this.saveCart()
      },
  
      increase(item) {
        item.quantity++
        item.total = item.quantity * item.price
        this.saveCart()
      },
  
      decrease(item) {
        if (item.quantity > 1) {
          item.quantity--
          item.total = item.quantity * item.price
          this.saveCart()
        }
      },
      checkout(){
        this.$router.push('/checkout')
        this.$emit("close")
      }
    }
  }
  </script>
  